import type { MuiSxProps } from "@dealer-center/core-components";
import {
  Button,
  Modal,
  ModalContent,
  ModalFooter
} from "@dealer-center/core-components";
import { useContext, useEffect, useState } from "react";
import { configItemContext } from "../../ConfigArea/inputList";
import { ImportModalConfig } from "./config";
import { ImportModalAccount } from "./account";
import { ImportModalSave } from "./save";
import { useInventoryConfigGet } from "@dealer-center/ddc-pages-inventory-config-fetch";

export const ImportModal = ({ sx }: { sx?: MuiSxProps }) => {
  const { curentConfig, setImportedConfig } = useContext(configItemContext);
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<string | null>(null);

  const [selectedConfigName, setSelectedConfigName] = useState<string>("");
  const { data: selectedConfigData, isLoading: selectedConfigDataLoading } =
    useInventoryConfigGet({
      accountId: selectedAccount as string,
      inventoryId: selectedConfigName as string
    });
  useEffect(() => {
    setSelectedAccount(null);
    setSelectedConfigName("");
  }, [showImportModal]);
  if (!curentConfig) return null;
  const configSelected = () => {
    if (!selectedConfigData || selectedConfigDataLoading) return;
    const newConfig = {
      ...selectedConfigData,
      id: curentConfig.id,
      accountId: curentConfig.accountId,
      inventoryId: curentConfig.inventoryId
    };
    setImportedConfig(newConfig);
  };
  return (
    <>
      <Button
        analyticsConfiguration={{
          eventName: "Website Inventory Config Import Configuration clicked"
        }}
        buttonStyle="secondary"
        sx={sx}
        onClick={() => setShowImportModal(true)}
      >
        Import Configuration
      </Button>
      <Modal
        footer={{
          primary: {
            label: "unused"
          },
          footerComponent: (
            <ModalFooter>
              <ImportModalSave
                configSaved={configSelected}
                selectedConfig={selectedConfigName}
                selectedConfigDataLoading={selectedConfigDataLoading}
                setShowImportModal={setShowImportModal}
              />
            </ModalFooter>
          )
        }}
        header="Import Configuration from another account"
        show={showImportModal}
        size="fullScreen"
        onHide={() => setShowImportModal(false)}
      >
        <ModalContent>
          <ImportModalAccount setSelectedAccount={setSelectedAccount} />
          {selectedAccount && (
            <ImportModalConfig
              selectedAccount={selectedAccount}
              selectedConfigName={selectedConfigName}
              setSelectedConfigName={setSelectedConfigName}
            />
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
